<template>
  <AppHeaderDropdown right no-caret>
    <template slot="header">
      <i class="fa fa-unlock" style="font-size: 30px;"></i>
    </template>\
    <template slot="dropdown">
      <b-dropdown-item v-on:click="logout()"><i class="fa fa-lock" /> Logout</b-dropdown-item>
    </template>
  </AppHeaderDropdown>
</template>

<script>
import { HeaderDropdown as AppHeaderDropdown } from '@coreui/vue'
export default {
  name: 'DefaultHeaderDropdownAccnt',
  components: {
    AppHeaderDropdown
  },
  data: () => {
    return { itemsCount: 42 }
  },
  methods: {
    logout: function () {
      this.$localStorage.remove('holly-fi-token');
      this.$localStorage.remove('holly-fi-user');
      window.location.href = "/";
    }
  }
}
</script>
